<template>
    <div class="progress-header-wrapper">
        <div v-for="n in 8" class="progress-track" :key="n"></div>
        <div
            class="progress-fill"
            :style="'width: calc((100% / 8) *' + step + ')'"
        ></div>
        <div></div>
    </div>
</template>

<script>
export default {
  name: "ProgressHeader",
  props: {
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.progress-header-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 10px;
    width: 100%;
    display: flex;
    border-radius: 3px 3px 0 0;
    overflow: hidden;
}
.progress-track {
    z-index: 1;
    background: rgba(245, 51, 63, 0.3);
    width: calc(100% / 8);
    height: 10px;
    border-right: 3px solid $white;
    &:nth-child(8n) {
        border-right: none;
    }
}
.progress-fill {
    position: absolute;
    background-color: $alt-red-active;
    height: 10px;
    /* width: calc((100% / 7) * 1); */
}
</style>
